import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from "@material-ui/core";

interface AlertDialogProps {
  title: string;
  content: any;
  confirmationText?: string;
  onAccept: Function;
  onCancel?: Function;
  mode: "YesNo" | "OK";
}

const AlertDialog = (props: AlertDialogProps) => {
  const { title, content, confirmationText, onAccept, onCancel, mode } = props;

  return (
    <Dialog open={true} fullWidth={true} maxWidth={"xs"}>
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText>
          {content}
          {confirmationText !== undefined && (
            <>
              <br />
              <br />
              {confirmationText}
            </>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {mode === "YesNo" && (
          <>
            <Button
              tc-data="dialogYes"
              onClick={() => onAccept()}
              variant="contained"
              color="secondary"
            >
              Tak
            </Button>
            <Button
              tc-data="dialogNo"
              onClick={() => onCancel && onCancel()}
              variant="contained"
              color="secondary"
            >
              Nie
            </Button>
          </>
        )}
        {mode === "OK" && (
          <>
            <Button
              tc-data="dialogOK"
              onClick={() => onAccept()}
              variant="contained"
              color="secondary"
            >
              OK
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
